export default __webpack_public_path__ + "locales/el-GR/DeleteProfileEverDialog.json?hash=306c126ccdc1e63e05016bede7d155e0";